// import qs from 'qs'
export default {
  data () {
    return {
      pagination: {
        total: 0,
        page: 1,
        rows: 10
      },
      // 编辑弹窗按钮事件
      fixButtons: [{
        label: '取消',
        eventKey: 'cancel'
      },
      {
        label: '确定',
        eventKey: 'edit-submit',
        type: 'primary',
        checkSubmit: true
      }
      ],
      // 新增弹窗按钮事件
      addButtons: [{
        label: '取消',
        eventKey: 'cancel'
      },
      {
        label: '确定',
        eventKey: 'add-submit',
        type: 'primary',
        checkSubmit: true
      }
      ]
    }
  },
  computed: {
    getRateOptions () {
      let arr = [];
      for (let i = 1.0; i <= 5;) {
        arr.push({ label: i.toFixed(1), value: i.toFixed(1) })
        i = parseFloat(i + 0.1)
      }
      return arr
    }
  },
  watch: {
    pagination (v) {
      if (this.back) {
        this.back = false;
        return
      }
      this.getTableData(this.searchData, v.page);
    }
  },
  methods: {
    formatterDate (row, column, cellValue, index) {
      if (!cellValue) { return '--' }
      cellValue = String(cellValue).indexOf('.000') === '-1' ? cellValue : String(cellValue).slice(0, -4);
      cellValue = String(cellValue).indexOf('-') === '-1' ? cellValue : String(cellValue).replace(/-/g, '/');
      let Y = new Date(cellValue).getFullYear();
      let M = new Date(cellValue).getMonth() + 1;
      let D = new Date(cellValue).getDate();
      let h = new Date(cellValue).getHours();
      let m = new Date(cellValue).getMinutes();
      M = M < 10 ? ('0' + M) : M;
      D = D < 10 ? ('0' + D) : D;
      h = h < 10 ? ('0' + h) : h;
      m = m < 10 ? ('0' + m) : m;
      return Y + '-' + M + '-' + D + ' ' + h + ':' + m
    },
    formatterNull (row, column, cellValue, index) {
      return !cellValue ? '--' : cellValue
    },
    formatterRegional (row, column, cellValue, index) {
      return row.provinceName + ' ' + row.cityName
    },
    formatterImage (row, column, cellValue, index) {
      return this.$preffix + cellValue
    },
    // 级联获取省市
    lazyLoadProvinceCity (node, resolve) {
      this.$axios.post('/area/getAddress', this.$qs.stringify({
        level: node.level + 1,
        parentId: node.level === 1 ? node.data.id : ''
      })).then(res => {
        let arr = res.data.data;
        resolve(arr.map(v => {
          return {
            label: v.areaName,
            value: v.areaCode,
            id: v.areaId,
            leaf: node.level === 1
          }
        }));
      })
    },
    // 级联获取省市区
    lazyLoadProvinceCityArea (node, resolve) {
      this.$axios.post('/area/getAddress', this.$qs.stringify({
        level: node.level + 1,
        parentId: node.level === 0 ? '' : node.data.id
      })).then(res => {
        let arr = res.data.data;
        resolve(arr.map(v => {
          return {
            label: v.areaName,
            value: v.areaId,
            id: v.areaId,
            leaf: node.level === 2
          }
        }));
      })
    },
    formatterSex (r, b, c) {
      return c === '1' ? '女' : '男'
    },
    formatterIdType (r, b, c) {
      switch (c) {
        case '01': return '身份证'
        case '02': return '护照'
        case '99': return '其他'
      }
    }
  },
  created () {
    console.log('absl')
  }
}



// WEBPACK FOOTER //
// ./src/mixin/table.js